import React from 'react'

import ServicesPic from '../Images/Services.jpg'


const ServicesSection = props => {
    return (
        <div 
          className='ServicesSection'
          // style={{ 
          //     backgroundImage: 'url(' + ServicesPic + ')',
          //     // opacity: '0.5'
          // }}
        >
          <div className='ServicesBackground'
            style={{ 
                position: 'absolute',
                backgroundImage: 'url(' + ServicesPic + ')',
                opacity: '0.5',
                width: '100%',
                // height: 'auto',
                zIndex: '-1',
                backgroundPosition: 'center',
                overflowX: 'hidden'
            }}
          >
            <img src={ServicesPic}
              style={{
                visibility: 'hidden'
              }}
            />
          </div>

          <div className='ServicesBox'>
            <div className='Title'><b></b>Our <span>Services</span></div>
            <div className='Description'>
              First, let us know which product you would like us to customize. 
              <br />

              Then, give us the pictures you want us to place onto it. 
              We’ve made an easy online process for our customers to help us 
              visualize their creation. 
              <br />

              <br />
              
              Our products don’t stop with what we have online. 
              Send us an email at caigoycreations@gmail.com and let us know what 
              you’d like us to create for you.
            </div>

            <div className='Contact'>
              <a href="MailTo://caigoycreations@gmail.com" className='ContactButton'>Contact Us</a>
            </div>
          </div>
        </div>
    )
}

export default ServicesSection